import React from "react";
import { Anchor, Box, Paragraph } from "grommet";
import { EDUCATION } from "../../mocks/education";
export var EducationItem = function EducationItem() {
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      gap: "large",
    },
    EDUCATION.map(function (e) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          key: e.id,
          gap: "small",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          null,
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              fill: true,
            },
            e.content
          )
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            gap: "xsmall",
          },
          /*#__PURE__*/ React.createElement(
            Paragraph,
            null,
            /*#__PURE__*/ React.createElement(
              "strong",
              null,
              "\u0421\u0440\u043E\u043A \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u044F: "
            ),
            e.time
          ),
          /*#__PURE__*/ React.createElement(
            Paragraph,
            null,
            /*#__PURE__*/ React.createElement(
              "strong",
              null,
              "\u0424\u043E\u0440\u043C\u0430 \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u044F: "
            ),
            e.form
          )
        )
      );
    }),
    /*#__PURE__*/ React.createElement(
      Box,
      {
        gap: "xsmall",
      },
      /*#__PURE__*/ React.createElement(
        Paragraph,
        null,
        /*#__PURE__*/ React.createElement("strong", null, "\u0410\u0434\u0440\u0435\u0441: "),
        "\u0433. \u041C\u043E\u0441\u043A\u0432\u0430, \u0421\u0438\u0440\u0435\u043D\u0435\u0432\u044B\u0439 \u0431\u0443\u043B\u044C\u0432\u0430\u0440, \u0434\u043E\u043C 4"
      ),
      /*#__PURE__*/ React.createElement(
        Anchor,
        {
          href: "https://www.sportedu.ru/",
        },
        "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442"
      )
    )
  );
};
